import { render, staticRenderFns } from "./veBaseStudentShow.vue?vue&type=template&id=40c0005f&scoped=true"
import script from "./veBaseStudentShow.vue?vue&type=script&lang=js"
export * from "./veBaseStudentShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c0005f",
  null
  
)

export default component.exports